export enum UploadItemType {
  Process,
  CustomerFile,
}
